export function showSuccess(message, timeout = 5000, icon = 'mdi-check') {
    window.EventBus.$emit('notify', {
        message: {
            icon: icon,
            text: message,
        },
        color: 'success',
        timeout,
    });
}

export function showWarning(message, timeout = 5000) {
    window.EventBus.$emit('notify', {
        message: {
            icon: 'mdi-alert-outline',
            text: message,
        },
        color: 'warning',
        timeout,
    });
}

export function showError(message, timeout = 5000) {
    window.EventBus.$emit('notify', {
        message: {
            icon: 'mdi-alert-circle-outline',
            text: message,
        },
        color: 'error',
        timeout,
    });
}

export function clampValue(min, max, value, mustReturnNumber = true) {
    if (mustReturnNumber) {
        value = parseInt(value) || 0;
    } else {
        value = parseInt(value) || '';
    }

    if (value > max) {
        return max;
    }

    if (value < min) {
        return min;
    }

    return value;
}

export function validateInput(event) {
    event = event ? event : window.event;

    const input = event.data?.toString();

    if (input == '.' || input == ',' || input == 'e' || input == '-') return event.preventDefault();
}

export function parseQuantity(quantity, acceptZero = true) {
    let newQuantity = 0;

    if (acceptZero) {
        newQuantity = isNaN(quantity) ? 0 : parseInt(quantity) || 0;
    } else {
        newQuantity = isNaN(quantity) ? 1 : parseInt(quantity) || 1;
    }

    if (newQuantity <= 0 && !acceptZero) {
        newQuantity = 1;
    } else if (newQuantity < 0) {
        newQuantity = 0;
    }

    return newQuantity;
}

export function scrollDatatableToTop(vuetifyInstance, wrapper = null) {
    const targetWrapper = wrapper ? wrapper : '.v-data-table__wrapper';
    vuetifyInstance.goTo('table tbody tr', {
        offset: window.innerHeight, // scroll up as much as possible, starting from the bottom of the target element
        container: targetWrapper,
        duration: 0, // instant "jump", no smoothness
    });
}

export function getResponsiveDialogWidth(mobileValue = '90vw', desktopValue = '65vw') {
    return ['xs', 'sm', 'md'].includes(this.$vuetify.breakpoint.name) ? mobileValue : desktopValue;
}

export function getResponsiveDialogHeight(mobileValue = '25vh', desktopValue = '20vh') {
    return ['xs', 'sm', 'md'].includes(this.$vuetify.breakpoint.name) ? mobileValue : desktopValue;
}

export function setHeightByStringSize(string,margin) {
    let size= _.size(_.trim(string))
    //console.log('getStringSize', _.trim(string),size);
    if(margin){
        return  _.size(string)+ margin
    }
    if(size > 22 && size < 43){
        return 44
    }
    if(size > 44 && size < 63){
        return 60
    }
    return size ;
}

export function isIOS() {
    return ([
            'iPad Simulator',
            'iPhone Simulator',
            'iPad',
            'iPhone',
        ].includes(navigator.platform)
        ||
        (navigator.userAgent.includes("Mac") && "ontouchend" in document))?true:false;
    //return rs
}

export function  checkConnection(){
    // Check if device has network connectivity
    if (!navigator.onLine) {
            return false
        }
       // Verify connection quality and type (optional)
        if (navigator.connection) {
            const connection = navigator.connection;
            // check if device connection is slow or unstable
            if (connection.effectiveType === 'slow-2g' || connection.effectiveType === '2g') {
                return false
            }
        }
    return true
}
